import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import GurukulCampus from "../pages/GurukulCampus";
import AdmissionForm from "../pages/AdmissionForm"; // Page without layout
// import GurukulPage from "../pages/GurukulPage";
import StaffHiring from "../pages/StaffHiring";
import Layout from "../layouts/Layout";
import Admission from "../pages/Admission"
import Facilities from "../pages/Facilities";
import About from "../pages/About";
import Hostel from "../pages/Hostel";
import Transportation from "../pages/Transportation";
import Login from "../pages/Login";
import DashboardPage from "../pages/DashboardPage";
import ProtectedRoute from "../components/ProtectedRoute";
import MayalwasGurukul from "../pages/Campus/Mayalawas-Campus";
import HiringGuideline from "../pages/HiringGuideline";
import SawaiChotiCampus from "../pages/Campus/SawaiChotiCampus";
import BijrolKhedaCampus from "../pages/Campus/BijrolKhedaCampus";
import SayalaCampus from "../pages/Campus/SayalaCampus";
import RaithalCampus from "../pages/Campus/RaithalCampus";
import VedicStorePage from "../pages/VedicStore/Vedic/VedicStorePage";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Pages WITH Header and Footer */}
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/gurukulCampus" element={<GurukulCampus />} />
        {/* <Route path="/gurukul/:campus" element={<GurukulPage />} /> */}
        <Route path="/gurukul/mayalawas-gurukul" element={<MayalwasGurukul />} />
        <Route path="/gurukul/sawai-choti-gurukul" element={<SawaiChotiCampus />} />
        <Route path="/gurukul/bijrol-kheda-gurukul" element={<BijrolKhedaCampus />} />
        <Route path="/gurukul/sayala-gurukul" element={<SayalaCampus />} />
        <Route path="/gurukul/raithal-gurukul" element={<RaithalCampus />} />
        <Route path="/admission" element={<Admission />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/facility/hostel" element={<Hostel />} />
        <Route path="/facility/transportation" element={<Transportation />} />
        <Route path="/about" element={<About />} />
        <Route path="/vedic-store" element={<VedicStorePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/hiring-guideline" element={<HiringGuideline />} />
        <Route path="/admissionForm" element={<AdmissionForm />} />
      </Route>

      {/* Pages WITHOUT Header and Footer */}
      
      <Route path="/hiring" element={<StaffHiring />} />
      
      <Route 
          path="/dashboard/*" 
          element={
              <ProtectedRoute>
                  <DashboardPage />
              </ProtectedRoute>
          } 
      />
    </Routes>
  );
};

export default AppRoutes;
